import { Tag, Text } from "../units/Text"
import { Table, Body, Head, Row, Th, Td, Paginator, NoDataComponent } from "../Tables/Table"
import { FC } from "react"
import { BoxWrapper } from "../Wrappers/Wrappers";
import { LoadingTableCell } from "../Loading/Loading";
import { OrderController } from "../Tables/Table";
import { ACBRangedListParams, DeviceListResponse } from "../Rest/RestAcbList";
import { selectedDateRangeLabel } from "../Pickers/dataRange";
import { Section } from "../../pages/Organization/Organization";
import { useState } from "react";
import { DetailText } from "../units/Text";


const tableNoData = 'Нет данных'


interface AcbRangedTableProps {
    data: DeviceListResponse | undefined;
    currentPage: number;
    itemsPerPage: number;
    params: ACBRangedListParams;
    setter: (value: number) => void;
    orderSetter: (value: string) => void;
    setSection: (value: any, section: Section) => void;
}


export const DeviceTable:FC<AcbRangedTableProps> = ({ data, currentPage, itemsPerPage, params, setter, orderSetter, setSection }):JSX.Element => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
  
    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
      setPosition({ x: e.clientX - 210, y: e.clientY - 12 }); // Offset to avoid overlapping cursor
    };
    
    return (
        <BoxWrapper p="p0" bg="bg-primary" className="x-scroll relative" r="r15"
        >
            <Table className="">
                <Head>
                    <Row>
                        <Th className="align-center table-align-left">
                            <BoxWrapper className="flex align-center space-between" p="p0" style={{paddingRight: "5px", minWidth: '250px'}}>
                                Вид техники
                                <OrderController 
                                    order={params.ordering} 
                                    value={'device_name'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Название Объекта
                                <OrderController 
                                    order={params.ordering} 
                                    value={'building_name'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-175">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Кол-во АКБ
                                <OrderController 
                                    order={params.ordering} 
                                    value={'acb_count'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Активность
                                <Tag>{selectedDateRangeLabel(params.dateRange.range)}</Tag>
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center col-175">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Потребление
                                <Tag>{selectedDateRangeLabel(params.dateRange.range)}</Tag>
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-100">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Статус
                                <OrderController 
                                    order={params.ordering} 
                                    value={'errors'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                    </Row>
                </Head>
                <Body className="relative table-helper-body"
                    // onMouseMove={handleMouseMove}
                    >
                    { data?.results ? (data.results.map((item, index) => (
                        <Row key={index} className="show-up-quick cursor-pointer">

                            <Td className="table-align-left">
                                <Text color="orange" className="device-grp-label underline" onClick={(value: any) => { setSection(item.id, Section.ACBList) }}>
                                    { item.device_name !== null && item.device_name !== "" ? item.device_name: tableNoData}
                                    <div className="helper flex align-center show-up-quick">
                                        <Text>Перейти к типам АКБ→</Text>
                                    </div>
                                </Text>    
                            </Td>
                            <Td className="table-align-left">{ item.building_name !== null && item.building_name !== "" ? item.building_name : tableNoData }</Td>
                            <Td className="table-align-left">{ item.acb_count !== null ? item.acb_count : tableNoData }</Td>
                            <Td className="table-align-right">
                                { item.idle_share + item.charge_share + item.discharge_share > 0 ? (
                                    <div
                                        style={{
                                            width: '180px',
                                            height: '18px',
                                            borderRadius:'10px',
                                            display: 'flex',
                                            overflow: 'hidden',
                                            border: "1px solid #ccc"
                                        }}
                                    >
                                        <div style={{height: '100%', width: `${item.discharge_share}%`, background: '#FF8200'}} className="flex align-center justify-center">
                                            {
                                                item.discharge_share >= 25 && (
                                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6.58776 14.8238L12.8102 2.37891C12.8574 2.28453 12.9996 2.31811 12.9996 2.42364V9.26151C12.9996 9.61524 13.3569 9.85712 13.6853 9.72575L16.7786 8.48844C17.2055 8.31769 17.6171 8.76507 17.4115 9.17629L11.1891 21.6211C11.1419 21.7155 10.9996 21.6819 10.9996 21.5764V14.7385C10.9996 14.3848 10.6424 14.1429 10.3139 14.2743L7.22067 15.5116C6.79379 15.6824 6.38215 15.235 6.58776 14.8238Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/>
                                                    </svg>
                                                )
                                            }

                                        </div>
                                        <div style={{height: '100%', width: `${item.charge_share}%`, background: '#4ADE29'}} className="flex align-center justify-center">
                                            { item.charge_share >= 25 && (
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.2 18C6.75228 18 7.2 17.5523 7.2 17C7.2 16.4477 6.75228 16 6.2 16V18ZM4.09202 16.782L4.54601 15.891H4.54601L4.09202 16.782ZM3.21799 15.908L2.32698 16.362L3.21799 15.908ZM18.782 15.908L17.891 15.454L18.782 15.908ZM17.908 16.782L17.454 15.891L17.908 16.782ZM15.8 6C15.2477 6 14.8 6.44772 14.8 7C14.8 7.55228 15.2477 8 15.8 8V6ZM17.908 7.21799L18.362 6.32698L17.908 7.21799ZM18.782 8.09202L17.891 8.54601V8.54601L18.782 8.09202ZM4.09202 7.21799L4.54601 8.10899L4.54601 8.10899L4.09202 7.21799ZM3.21799 8.09202L4.10899 8.54601L4.10899 8.54601L3.21799 8.09202ZM7 8C7.55228 8 8 7.55228 8 7C8 6.44772 7.55228 6 7 6V8ZM15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18V16ZM23 11C23 10.4477 22.5523 10 22 10C21.4477 10 21 10.4477 21 11H23ZM21 13C21 13.5523 21.4477 14 22 14C22.5523 14 23 13.5523 23 13H21ZM12.7593 7.65079C13.1187 7.23147 13.0701 6.60017 12.6508 6.24074C12.2315 5.88132 11.6002 5.92988 11.2407 6.34921L12.7593 7.65079ZM8.70748 10.8413L7.94823 10.1905L7.94823 10.1905L8.70748 10.8413ZM13.4 12.4667L14.2 13.0667V13.0667L13.4 12.4667ZM9.2 16.4C8.86863 16.8418 8.95817 17.4686 9.4 17.8C9.84183 18.1314 10.4686 18.0418 10.8 17.6L9.2 16.4ZM18 10.2V13.8H20V10.2H18ZM4 13.8V10.2H2V13.8H4ZM6.2 16C5.62345 16 5.25117 15.9992 4.96784 15.9761C4.69617 15.9539 4.59545 15.9162 4.54601 15.891L3.63803 17.673C4.01641 17.8658 4.40963 17.9371 4.80497 17.9694C5.18864 18.0008 5.65645 18 6.2 18V16ZM2 13.8C2 14.3436 1.99922 14.8114 2.03057 15.195C2.06287 15.5904 2.13419 15.9836 2.32698 16.362L4.10899 15.454C4.0838 15.4045 4.04612 15.3038 4.02393 15.0322C4.00078 14.7488 4 14.3766 4 13.8H2ZM4.54601 15.891C4.35785 15.7951 4.20487 15.6422 4.10899 15.454L2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673L4.54601 15.891ZM18 13.8C18 14.3766 17.9992 14.7488 17.9761 15.0322C17.9539 15.3038 17.9162 15.4045 17.891 15.454L19.673 16.362C19.8658 15.9836 19.9371 15.5904 19.9694 15.195C20.0008 14.8114 20 14.3436 20 13.8H18ZM15.8 18C16.3436 18 16.8114 18.0008 17.195 17.9694C17.5904 17.9371 17.9836 17.8658 18.362 17.673L17.454 15.891C17.4045 15.9162 17.3038 15.9539 17.0322 15.9761C16.7488 15.9992 16.3766 16 15.8 16V18ZM17.891 15.454C17.7951 15.6422 17.6422 15.7951 17.454 15.891L18.362 17.673C18.9265 17.3854 19.3854 16.9265 19.673 16.362L17.891 15.454ZM15.8 8C16.3766 8 16.7488 8.00078 17.0322 8.02393C17.3038 8.04612 17.4045 8.0838 17.454 8.10899L18.362 6.32698C17.9836 6.13419 17.5904 6.06287 17.195 6.03057C16.8114 5.99922 16.3436 6 15.8 6V8ZM20 10.2C20 9.65645 20.0008 9.18864 19.9694 8.80497C19.9371 8.40963 19.8658 8.01641 19.673 7.63803L17.891 8.54601C17.9162 8.59545 17.9539 8.69617 17.9761 8.96784C17.9992 9.25117 18 9.62345 18 10.2H20ZM17.454 8.10899C17.6422 8.20487 17.7951 8.35785 17.891 8.54601L19.673 7.63803C19.3854 7.07354 18.9265 6.6146 18.362 6.32698L17.454 8.10899ZM6.2 6C5.65645 6 5.18864 5.99922 4.80497 6.03057C4.40963 6.06287 4.01641 6.13419 3.63803 6.32698L4.54601 8.10899C4.59545 8.0838 4.69617 8.04612 4.96784 8.02393C5.25117 8.00078 5.62345 8 6.2 8V6ZM4 10.2C4 9.62345 4.00078 9.25117 4.02393 8.96784C4.04612 8.69617 4.0838 8.59545 4.10899 8.54601L2.32698 7.63803C2.13419 8.01641 2.06287 8.40963 2.03057 8.80497C1.99922 9.18864 2 9.65645 2 10.2H4ZM3.63803 6.32698C3.07354 6.6146 2.6146 7.07354 2.32698 7.63803L4.10899 8.54601C4.20487 8.35785 4.35785 8.20487 4.54601 8.10899L3.63803 6.32698ZM6.2 8H7V6H6.2V8ZM15.8 16H15V18H15.8V16ZM21 11V13H23V11H21ZM11.2407 6.34921L7.94823 10.1905L9.46674 11.4921L12.7593 7.65079L11.2407 6.34921ZM9.08711 12.6667H13V10.6667H9.08711V12.6667ZM12.6 11.8667L9.2 16.4L10.8 17.6L14.2 13.0667L12.6 11.8667ZM13 12.6667C12.588 12.6667 12.3528 12.1963 12.6 11.8667L14.2 13.0667C14.9416 12.0778 14.2361 10.6667 13 10.6667V12.6667ZM7.94823 10.1905C7.11422 11.1635 7.80558 12.6667 9.08711 12.6667V10.6667C9.51429 10.6667 9.74474 11.1677 9.46674 11.4921L7.94823 10.1905Z" fill="#FFFFFF"/>
                                                </svg>
                                                
                                            )}

                                        </div>
                                        <div style={{height: '100%', width: `${item.idle_share}%`, background: '#f8f9fa'}}>

                                        </div>
                                    </div>
                                ) : (
                                    <Text>Нет данных</Text>
                                ) }
                            </Td>
                            <Td className="table-align-right">{Math.round(item.energy_discharge_delta)} кВтч</Td>
                            <Td className="table-align-right">{item.errors === 0 ? '🟢' :  item.errors}</Td>
                        </Row>
                    ))) : (
                        Array.from({ length: itemsPerPage }, (_:any, index:number) => {
                            return (
                                <Row className="" key={index}>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                    <Td><LoadingTableCell/></Td>
                                </Row>
                            )
                        }) 
                    )
                }
                </Body>
            </Table>
            { data?.results?.length === 0 && <NoDataComponent/> }
            <Paginator
                key={data?.results ? data.results.length + 1 : 0}
                itemsPerPage={itemsPerPage} 
                totalItems={data ? data.count : 1} 
                currentPage={currentPage} 
                setPage={setter}/>
        </BoxWrapper>
    )
}
